"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasDefaultDesign;
function hasDefaultDesign(newTemplate) {
  var _a, _b;
  const defaultOrderDesigns = (_b = (_a = newTemplate === null || newTemplate === void 0 ? void 0 : newTemplate.template) === null || _a === void 0 ? void 0 : _a.designs) === null || _b === void 0 ? void 0 : _b.filter(design => (design === null || design === void 0 ? void 0 : design.order) !== undefined);
  const defaultDesigns = defaultOrderDesigns === null || defaultOrderDesigns === void 0 ? void 0 : defaultOrderDesigns.filter(design => (design === null || design === void 0 ? void 0 : design.default) === true);
  let hasDefaultDesign;
  if ((defaultDesigns === null || defaultDesigns === void 0 ? void 0 : defaultDesigns.length) > 0) {
    hasDefaultDesign = true;
  } else {
    hasDefaultDesign = false;
  }
  return hasDefaultDesign;
}